import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from './components/Navbar';
import Home from './views/Home';
import About from './views/About';
import ThankYou from "./views/ThankYou";
import Contact from './views/Contact';
import Project from './views/Project';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Fallback from "./views/Fallback";

function App() {
  const location = useLocation();
  
  return (
    <HelmetProvider>
      <Navbar page={location.pathname} />
      <ScrollToTop />
      <AnimatePresence mode='wait'>
        <Routes location={location} key={location.pathname}>
          <Route index element={<Home />} />
          <Route path='/project/:handle' element={<Project />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/thankyou' element={<ThankYou />} />
          <Route path='*' element={<Fallback />} />
        </Routes>
        <Footer />
      </AnimatePresence>
    </HelmetProvider>
  );
}

export default App;